/*
** $Id$
**
** Copyright 2020 Port25 Solutions, Inc.
** All rights reserved.
*/


/**
 * Shorter refresh interval (in milliseconds) for pages such as home and status.
 */
export const SHORT_REFRESH_INTERVAL = 5 * 1000;


/**
 * Longer refresh interval (in milliseconds) for pages such as queues, jobs, domains etc. 
 *
 * Use this to reduce chances of running into performance problems (including potentially impacting
 * email delivery) by frequently hitting possibly unoptimized code paths in PowerMTA.
 */
export const LONG_REFRESH_INTERVAL = 120 * 1000;
